import LabServiceModel from "@/models/LabServiceModel";
import TestPackageModel from "@/models/lab/TestPackageModel";
import AnalyteCollection from "@/collections/lab/AnalyteCollection";

export default class TestPackageSampleModel extends LabServiceModel {
  modelName() {
    return "test-package-sample";
  }
  defaults() {
    return {
      id: null,
      test_package_id: null,
      name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_package: null,
      analytes: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      test_package_id: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getTestPackage() {
    return this.getRelatedModel(TestPackageModel, "test_package");
  }
  getAnalytes() {
    return this.getRelatedCollection(new AnalyteCollection(), "analytes");
  }
}
